import { render } from "./RecipeTile.vue?vue&type=template&id=8969ccca"
import script from "./RecipeTile.vue?vue&type=script&lang=js"
export * from "./RecipeTile.vue?vue&type=script&lang=js"

import "./RecipeTile.vue?vue&type=style&index=0&id=8969ccca&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__